// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__3Sls5","alertIcon":"ConfirmModal_alertIcon__DNus7"};